import React from "react";
import CustomModal from "../../common/CustomModal";

interface Role {
  roleResourceId: number;
  role: string;
}

interface AddUserModalProps {
  show: boolean;
  onHide: () => void;
  name: string;
  email: string;
  password: string;
  roleId: number;
  roles: Role[];
  onNameChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onRoleIdChange: (value: number) => void;
  onSubmit: () => void;
}

export const AddUserModal: React.FC<AddUserModalProps> = ({
  show,
  onHide,
  name,
  email,
  password,
  roleId,
  roles,
  onNameChange,
  onEmailChange,
  onPasswordChange,
  onRoleIdChange,
  onSubmit,
}) => {
  return (
    <CustomModal show={show} onHide={onHide} title="User" width="w-[500px]">
      <div className="w-full">
        <div className="space-y-4">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => onNameChange(e.target.value)}
              placeholder="Enter user name"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
            />
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => onEmailChange(e.target.value)}
              placeholder="Enter user email"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
            />
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => onPasswordChange(e.target.value)}
              placeholder="Enter password"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
            />
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Role</label>
            <div className="relative">
              <select
                value={roleId}
                onChange={(e) => onRoleIdChange(Number(e.target.value))}
                className="block w-full px-3 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-700 focus:outline-none appearance-none transition"
              >
                {roles.map((role) => (
                  <option key={role.roleResourceId} value={role.roleResourceId}>
                    {role.role}
                  </option>
                ))}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-400">
                <svg
                  className="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-between gap-4 mt-8">
          <button
            onClick={onHide}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none"
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            className="px-4 py-2 text-sm font-medium text-white bg-brand rounded-md hover:bg-brand/80 focus:outline-none"
          >
            Add User
          </button>
        </div>
      </div>
    </CustomModal>
  );
};
